import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import ContentWrapper from '../../shared/ContentWrapper'
import ModalWindow from '../ModalWindow'
import Button from '../../shared/Button'
import {
  METAL,
  MANTIS,
  YELLOW,
  RED,
  TEXT_SMALL,
  ICON_SIZE_MEDIUM,
} from '../../../constants'
import StructuredTable from '../../shared/StructuredTable'
import { SECONDARY_BUTTON } from '../../../constants/buttonThemes'
import { FaClock, FaCheckCircle, FaMinusCircle, FaEdit } from 'react-icons/fa'
import { auditUrl } from '../../../constants/urls'

const OverflowWrapper = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`

const ButtonsInRowContainer = styled.div`
  display: flex;
  gap: 10px;
  height: 100%;
`

const CellCenter = styled.div`
  vertical-align: middle;
  display: table-cell;
  white-space: no-wrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`

const FeedAuditHistoryData = ({ onClose, visible, historyData, feedName }) => {
  const { t } = useTranslation()

  function doNothing() {}

  const openInNewTab = row => {
    let url = `${auditUrl}/report_${row.id}`
    window.open(url, '_blank', 'noreferrer')
  }

  function AuditStatusIcon(status) {
    var auditStatusInformation = auditStatus[status]
    var color = auditStatusInformation.color
    return (
      <div
        style={{
          marginRight: '5px',
          verticalAlign: 'middle',
          display: 'inline-block',
          position: 'relative',
          height: `${ICON_SIZE_MEDIUM}px`,
        }}
      >
        <auditStatusInformation.icon
          size={ICON_SIZE_MEDIUM}
          verticalAlign="middle"
          display="inline-block"
          color={color}
        />
      </div>
    )
  }
  function TextNoWrap(text) {
    return (
      <CellCenter>
        <span
          fontSize={TEXT_SMALL}
          font-family="DM Sans"
          color={METAL}
          text-overflow="ellipsis"
        >
          {text == 0
            ? t('audit_failed')
            : text == 1
            ? t('audit_success')
            : text == 2
            ? t('audit_progress')
            : text == 3
            ? t('audit_recalculating')
            : text == 4
            ? t('audit_recalculationFailed')
            : text == 5
            ? t('audit_pending')
            : ''}
        </span>
      </CellCenter>
    )
  }
  const auditStatus = {
    0: { color: RED, icon: FaMinusCircle },
    1: { color: MANTIS, icon: FaCheckCircle },
    2: { color: YELLOW, icon: FaClock },
    3: { color: YELLOW, icon: FaClock },
    4: { color: RED, icon: FaCheckCircle },
    5: { color: YELLOW, icon: FaClock },
  }

  const TableColumns = t => [
    {
      Header: t('feed_audit_table_header2'),
      accessor: 'auditTimestamp',
      Cell: row => {
        const {
          original: { auditTimestamp },
        } = row
        return auditTimestamp
          ? t('dateValueInput', {
              value: new Date(auditTimestamp),
            })
          : ''
      },
    },
    {
      Header: t('feed_audit_table_header5'),
      accessor: 'score',
      sortUndefined: 'last',
      Cell: row => {
        if (row.original.score != null) {
          const content = <>{row.original.score + '%'}</>
          return <OverflowWrapper>{content}</OverflowWrapper>
        }
      },
      minWidth: 50,
      maxWidth: 80,
    },
    {
      Header: t('feed_audit_table_header4'),
      accessor: 'progressStatus',
      Cell: row => {
        const content = (
          <>
            {auditStatus[row.original.progressStatus]
              ? AuditStatusIcon(row.original.progressStatus)
              : ' '}
            {TextNoWrap(t(row.original.progressStatus))}
          </>
        )
        return <>{content}</>
      },
      minWidth: 90,
      maxWidth: 150,
    },
    {
      Header: t('view_report'),
      width: 120,
      Cell: row => {
        const {
          original: { id },
        } = row
        return (
          <ButtonsInRowContainer>
            <Button
              onClick={() => openInNewTab(row.original)}
              theme={SECONDARY_BUTTON}
              fontSize={TEXT_SMALL}
              disabled={
                row.original.progressStatus !== 1 &&
                row.original.progressStatus !== 3 &&
                row.original.progressStatus !== 4
              }
            >
              {t('feedcheck')}
            </Button>
          </ButtonsInRowContainer>
        )
      },
    },
  ]

  return (
    <ModalWindow
      minWidth={'30%'}
      setWidth={'40%'}
      onCancel={onClose}
      cancelText={t('button_close')}
      title={t('feed_audit_history_title') + ' - ' + feedName}
      visible={visible}
    >
      {historyData && (
        <ContentWrapper>
          <StructuredTable
            columns={TableColumns(t)}
            data={historyData}
            rowPadding
            rightAlignLastColumn
            page={1}
            pageSize={10}
            pageTotal={historyData?.length ?? 0}
            showPagination={false}
            sortable={false}
            noPagination={true}
            selectNextPage={() => doNothing()}
            selectPreviousPage={() => doNothing()}
          />
        </ContentWrapper>
      )}
    </ModalWindow>
  )
}

export default FeedAuditHistoryData
